import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../config/Firebase";
import Header from "./Header";
import Footer from "./Footer";

export default function BuyNow() {
  const location = useLocation();
  const navigate = useNavigate();

  // Retrieve product and lens details from state or localStorage
  let { product, leftLens, rightLens, leftAxis, rightAxis, leftAdd, rightAdd } = location?.state || {};

  if (!product || !product.ProductID) {
    const storedProduct = localStorage.getItem("productForBuyNow");
    product = storedProduct ? JSON.parse(storedProduct) : null;
  }

  if (
    leftLens === undefined ||
    rightLens === undefined ||
    leftAxis === undefined ||
    rightAxis === undefined ||
    leftAdd === undefined ||
    rightAdd === undefined
  ) {
    const storedLens = localStorage.getItem("lensForBuyNow");
    if (storedLens) {
      const parsedLens = JSON.parse(storedLens);
      leftLens = parsedLens.leftLens;
      rightLens = parsedLens.rightLens;
      leftAxis = parsedLens.leftAxis;
      rightAxis = parsedLens.rightAxis;
      leftAdd = parsedLens.leftAdd;
      rightAdd = parsedLens.rightAdd;
    }
  }

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const phone = user.phone;

  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");

  if (!product || !product.ProductID) {
    return (
      <div className="text-center py-10">
        <p className="text-red-500">No product data found or Product ID is missing!</p>
        <button onClick={() => navigate(-1)} className="mt-4 px-4 py-2 bg-black text-white rounded">
          Go Back
        </button>
      </div>
    );
  }

  // Debug logs to verify product data and cost
  console.log("Product:", product);
  console.log("Product Cost:", product.Cost);

  // Function to initiate payment using Razorpay checkout modal
  const handlePayment = async () => {
    // Validate cost; fallback to 100 if missing/invalid
    const cost = product.Cost && !isNaN(parseFloat(product.Cost))
      ? parseFloat(product.Cost)
      : 100;
    const amountInPaise = cost * 100;
    console.log("Amount in paise to be sent:", amountInPaise);

    // Build payload for the PHP endpoint
    const payload = {
      amount: amountInPaise,
      currency: "INR",
      receipt: `receipt_order_${product.ProductID}`,
    };
    console.log("Payload being sent:", JSON.stringify(payload));

    try {
      const response = await fetch("https://arameyecare.com/server.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      console.log("Response status:", response.status);
      const responseText = await response.text();
      console.log("Response text:", responseText);

      let orderData;
      try {
        orderData = JSON.parse(responseText);
      } catch (parseError) {
        console.error("Error parsing JSON:", parseError);
        alert("Failed to initiate payment. Please try again.");
        return;
      }

      if (!response.ok) {
        console.error("Order creation error:", orderData);
        alert("Failed to initiate payment. Please try again.");
        return;
      }

      console.log("Order data received:", orderData);

      // Configure Razorpay checkout options
      const options = {
        key: "rzp_test_kIcYr7FmgXSulk", // Public test key
        amount: orderData.amount,
        currency: orderData.currency,
        name: "Your Company Name",
        description: "Product Purchase",
        order_id: orderData.id, // Order ID from backend
        handler: async function (response) {
          // Called on successful payment
          const orderDetails = {
            PaymentID: response.razorpay_payment_id,
            OrderID: response.razorpay_order_id,
            Signature: response.razorpay_signature,
            ProductID: product.ProductID,
            Cost: product.Cost,
            EmailID: email,
            Address: address,
            Phone: phone,
            LeftLensPower: leftLens || null,
            RightLensPower: rightLens || null,
            LeftAxis: leftAxis || null,
            RightAxis: rightAxis || null,
            LeftAdd: leftAdd || null,
            RightAdd: rightAdd || null,
          };

          try {
            // Save order details in Firestore
            const buyNowDocRef = doc(db, "BuyNow", phone);
            const buyNowDocSnap = await getDoc(buyNowDocRef);
            if (buyNowDocSnap.exists()) {
              const existingData = buyNowDocSnap.data();
              const existingProducts = existingData.Product || [];
              await updateDoc(buyNowDocRef, {
                Product: [...existingProducts, orderDetails],
              });
            } else {
              await setDoc(buyNowDocRef, {
                Product: [orderDetails],
              });
            }
            alert("Order placed and payment successful!");
            navigate("/");
          } catch (err) {
            console.error("Error saving order:", err.message);
            alert("Payment successful, but failed to save order. Please contact support.");
          }
        },
        prefill: {
          name: user.name || "",
          email: email,
          contact: phone,
        },
        theme: {
          color: "#3399cc",
        },
      };

      // Open the Razorpay checkout modal
      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      console.error("Error during payment initiation:", err);
      alert("Failed to initiate payment. Please try again.");
    }
  };

  // Handle form submission and trigger payment initiation
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!phone) {
      alert("Please login to proceed with the purchase.");
      return;
    }

    if (!email || !address) {
      alert("Please fill in all the fields.");
      return;
    }

    await handlePayment();
  };

  return (
    <>
      <Header />
      <div className="container mx-auto px-4 py-10">
        <h1 className="text-3xl font-bold text-center mb-6">Buy Now</h1>
        <div className="max-w-lg mx-auto bg-white p-6 rounded-lg shadow-md">
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-lg font-semibold mb-2">Email ID</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded"
                required
              />
            </div>
            <div className="mb-4">
              <label className="block text-lg font-semibold mb-2">Address</label>
              <textarea
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded"
                rows="4"
                required
              />
            </div>
            <div className="mb-4">
              <p className="text-lg">
                <span className="font-semibold">Product ID:</span> {product.ProductID || "Not Available"}
              </p>
            </div>
            <div className="mb-6">
              <p className="text-lg">
                <span className="font-semibold">Cost:</span> {product.Cost || "Not Specified"}
              </p>
            </div>
            <button type="submit" className="w-full bg-black text-white px-4 py-2 rounded">
              Place Order &amp; Pay
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
}
